import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/frontend/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/frontend/markdoc/tags.js'
import * as nodes from '/vercel/path0/frontend/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Podstawowe Funkcjonalności\ndescription: Podstawowe informacje na temat katalogowania książek.\n---\n\nDo podstawowych funkcjonalności należy generator, czytnik kodów QR i moduł BGS. Każdy nowy użytkownik jest samowystarczalny. To znaczy, że z podstawowym już kontem, może samodzielnie wygenerować kody, które po wydrukowaniu (dowolną metodą) i dodaniu do książek mogą być zeskanowane. Skanowanie kodu po wydrukowaniu otwiera tzw. _pusty kod_. Każdy może za pomocą smartfonu dodać do tego kodu informacje o książce. Po dodaniu jest ona przyporządkowana do właściciela konta, które wymagane jest do zalogowania.\n\n---\n\n## Zasady działania\n\nKażde skatalogowanie książki wymaga dwóch elementów - kodu oraz dowolnego smartfona, aby otworzyć kod i dodać do niego informację o tytule.\n\n### Powiązanie z unikalnym kodem QR\n\nPo co dodawać kody QR do książek? Załóżmy, że szukamy na biblioteczkach innych książki \"Filozofia Wschodu\". Jeśli znajdziemy w książce Wymiana z książek z innymi czytelnikami może być możliwa tylko jeśli będziemy mogli odróżnić. Nazywa się to _wyjątkowością_ i jest cechą systemu do katalogowania.\n\nPoza skatalogowaniem kody umożliwiają nam na:\n\n- Zmianę biblioteczki\n- Wymianę książki z innymi użytkownikami\n- Dodawanie notatek, nagrań do egzemplarza książki\n- Posiadanie prywatnej przestrzeni na każdym egzemplarzu książki ( dostępnej tylko dla osoby, która zeskanuje [kod QR](https://geex.x-kom.pl/lifestyle/co-to-jest-kod-qr-do-czego-sluzy/) )\n- Aktualizację stanu książki\n- Przyporządkowanie właściciela książki do egzemplarza.\n\n---\n\n## Używanie smartfonu\n\nDo skatalogowania książki, poza etykietą z kodem QR, potrzeba nam będzie smartfon z kamerą. Musimy bowiem zeskanować [kod QR](https://geex.x-kom.pl/lifestyle/co-to-jest-kod-qr-do-czego-sluzy/), aby otworzyć zawarty w nim link.\n\nKażda nowa etykieta QR jest pusta - nie powiązana z tytułem żadnej książki. Po otwarciu linku, który jest na niej zawarty otwieramy moduł. Modułem jest strona internetowa, która pojawia się tylko podczas pierwszego powiązania z książką.\n\n### 1. Aby skatalogować książkę, wystarczy wpisać lub zeskanować kod ISBN\n\n![Kody do katalogowania](/imgs/docs/bookle/bgs/bgs-module-main-01.png)\n\n### 2. Następnie kliknąć przycisk **Powiąż QR**\n\n![Kody do katalogowania](/imgs/docs/bookle/bgs/bgs-module-main-02.png)\n\nKsiążka z etykietą QR jest już nasza i zostajemy przekierowani do Bibliodesku.\n\n{% callout type=\"note\" title=\"Czy wiesz, że...\" %}\nteraz etykieta po zeskanowaniu przez kogoś innego będzie posiadać przycisk \"Dodaj na półkę\"? Właśnie to daje nam moc wymiany i śledzenia naszych książek.\n{% /callout %}\n";
const filepath = "/docs/katalogowanie-telefonem-smartfonem-qr-czytnikiem-isbn.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
